import styled from 'styled-components';

export const List = styled.ul`
  li li {
    list-style: outside;
  }
`;

export const ListItem = styled.li<{ display?: string }>`
  padding: 6px 0;

  > div {
    display: ${props => (props.display ? props.display : 'inline-flex')};
    > a {
      margin-right: 0;
    }
  }
`;
